var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('h6',{staticClass:"center-align"},[_vm._v(_vm._s(_vm.$t("SETTINGS.SETTINGS")))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("SETTINGS.SETTINGS-LINK"))+": "),_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.url))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d4294ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/settings-user.vue
// module id = null
// module chunks = 